import React, { useEffect, useState } from "react";
import { Users, Search, UserX, Mail } from "lucide-react";
import { fetchCustomers, eraseCustomer } from "../../lib/api";
import { toast } from "../../hooks/use-toast";

const CustomersPanel = () => {
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const load = () => fetchCustomers().then(setList).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  if (!list) return <div className="text-slate-400">Loading...</div>;

  const term = q.trim().toLowerCase();
  const shown = list.filter((c) => !term || `${c.name} ${c.email} ${c.country}`.toLowerCase().includes(term));
  const erase = async (c) => {
    if (!window.confirm(`Erase all personal info for ${c.email}? Their orders stay (for your records) but name, email and address are removed.`)) return;
    const r = await eraseCustomer(c.email);
    toast({ title: "Customer erased", description: `Removed info from ${r.orders} order(s).` });
    load();
  };

  return (
    <div data-testid="admin-customers-panel">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6">
        <h3 className="text-white font-bold text-lg inline-flex items-center gap-2"><Users size={18} className="text-gold" /> Customers ({shown.length})</h3>
        <div className="relative sm:w-72"><Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" /><input data-testid="customers-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search customers" className="w-full bg-navy-700 border border-white/15 focus:border-gold rounded-lg pl-9 pr-3 py-2 text-white text-sm outline-none" /></div>
      </div>
      {shown.length === 0 ? <p className="text-slate-400 text-center py-16">No customers yet.</p> : (
        <div className="overflow-x-auto rounded-2xl border border-white/10">
          <table className="w-full text-sm">
            <thead className="bg-navy-800 text-slate-400 text-xs uppercase tracking-wider">
              <tr><th className="text-left p-3">Customer</th><th className="text-left p-3">Country</th><th className="text-right p-3">Orders</th><th className="text-right p-3">Paid Total</th><th className="text-left p-3">Last Order</th><th className="p-3" /></tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {shown.map((c) => (
                <tr key={c.email} className="hover:bg-navy-800/60 transition-colors" data-testid={`customer-row-${c.email}`}>
                  <td className="p-3"><p className="text-white font-medium">{c.name}</p><p className="text-slate-400 text-xs">{c.email}</p></td>
                  <td className="p-3 text-slate-300">{c.country || "—"}</td>
                  <td className="p-3 text-right text-white" title={c.orderIds.join(", ")}>{c.orders}</td>
                  <td className="p-3 text-right text-gold font-semibold">${c.spent.toFixed(2)}</td>
                  <td className="p-3 text-slate-400 text-xs">{c.lastOrder ? new Date(c.lastOrder).toLocaleDateString() : ""}</td>
                  <td className="p-3">
                    <div className="flex justify-end gap-2">
                      <a href={`mailto:${c.email}`} title="Email" className="h-8 w-8 rounded-lg border border-white/15 text-slate-300 flex items-center justify-center hover:text-gold transition-colors"><Mail size={14} /></a>
                      <button onClick={() => erase(c)} title="Erase personal info" data-testid={`customer-erase-${c.email}`} className="h-8 w-8 rounded-lg border border-white/15 text-slate-400 flex items-center justify-center hover:text-red-400 transition-colors"><UserX size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CustomersPanel;
